import { Action, Location } from 'history';
import { LOCATION_CHANGE, push } from 'redux-first-history';
import { ActionType, createAction } from 'typesafe-actions';

import { logoutAsync } from '@bolteu/redux-session';

import { AccountActions } from 'rdx/account/actions';
import { PromotionsPermissionsAction } from 'rdx/promotions/actions';
import { SupportActions } from 'rdx/support/actions';
import { TargetingParametersActions } from 'rdx/targetingParameters/actions';

import { NotificationsActions } from './notifications';
import { PasswordActions } from './password';
import { ThemeActions } from './theme/actions';

export const emptyAction = createAction('@providerApp/EMPTY_ACTION')();
export const routeChangeAction = createAction(LOCATION_CHANGE)<{
  location: Location<never>;
  action: Action;
}>();

type AllActions = {
  emptyAction: typeof emptyAction;
  routeChangeAction: typeof routeChangeAction;
  logoutAsync: typeof logoutAsync;
};

export type GlobalAppActions =
  | ActionType<AllActions>
  | AccountActions
  | NotificationsActions
  | PasswordActions
  | SupportActions
  | ThemeActions
  | TargetingParametersActions
  | PromotionsPermissionsAction
  | ActionType<typeof push>;
